import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { InternalLevitateAccountIds } from '../../../models';
import { EnvironmentKey } from '../../../models/AppState';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { AdminPermission, AdminUserSessionContext } from '../../../viewmodels/AdminViewModels';
import { IPrivateRouteProps, PrivateRoute } from '../../../web/components/PrivateRoute';

interface IProps extends IPrivateRouteProps {
	requiredPermissions?: AdminPermission | AdminPermission[];
}

const AdminPrivateRouteSfc: React.FC<IProps> = props => {
	const { redirectPath, location, environment, requiredPermissions } = props;
	const userSession = useUserSession<AdminUserSessionContext>();

	if (
		environment.appType === 'admin' &&
		!!userSession &&
		!userSession.isLoading &&
		!userSession.isLoadingPermissions &&
		Object.keys(userSession.permissions || {}).length === 0
	) {
		if (userSession.account && !InternalLevitateAccountIds.has(userSession.account.id)) {
			return <Redirect to={{ pathname: '/logout', state: { from: location } }} />;
		}
		return <Redirect to={{ pathname: redirectPath || '/login', state: { from: location } }} />;
	}
	if (requiredPermissions) {
		const perms = Array.isArray(requiredPermissions) ? requiredPermissions : [requiredPermissions];
		if (!perms.every(x => !!userSession.permissions[x])) {
			return <Redirect to={redirectPath || '/'} push={false} />;
		}
	}
	return <PrivateRoute userSession={userSession} {...props} />;
};

const AdminPrivateRouteAsObserver = observer(AdminPrivateRouteSfc);
export const AdminPrivateRoute = inject(EnvironmentKey)(AdminPrivateRouteAsObserver);
